import { t } from "i18next";
import { IUnit } from "@/interfaces/nutrition/nutrition_builder";
import { ISelectOption } from "@/interfaces/components/select_option";


export const defaultFoodUnitUuid: string = '08d2276b-ea69-4671-b446-f7463a14b240';

export const defaultFoodUnit: IUnit = 
    { uuid: '08d2276b-ea69-4671-b446-f7463a14b240', label: t('components.select.options.foodServings.gram'), enum: 'gram', weight: 1 };

export const foodUnitOptions: IUnit[] = [
    { uuid: '08d2276b-ea69-4671-b446-f7463a14b240', label: t('components.select.options.foodServings.gram'), enum: 'gram', weight: 1 },
    { uuid: '771994f6-a13a-4f8b-a61a-16569048d8f7', label: t('components.select.options.foodServings.ounce'), enum: 'ounce', weight: 28.3495 },
    { uuid: '03795781-79d8-4b2f-8023-c57c8c2a912e', label: t('components.select.options.foodServings.millilitre'), enum: 'millilitre', weight: 1 },
    { uuid: 'f71b870e-7236-423a-b064-44ef19ddd7af', label: t('components.select.options.foodServings.fluidOunce'), enum: 'fluid_ounce', weight: 29.57352956255 },
];

export const foodLibraryTypeOptions: ISelectOption<string>[] = [
    { label: 'Custom', value: 'custom' },
    // { label: 'Default', value: 'default' },
    { label: 'Team', value: 'team' },
];

export const filterColumns = [
    { label: t('components.dataTable.headers.library'), field: 'library' }
]